export function useGenericFetchOptions() {
    const headers = new Headers();
    if (import.meta.server) {
        const appStore = useAppStore();
        if (appStore.clientIP) headers.set('x-forwarded-for', appStore.clientIP);
    }
    return { headers };
}
